const IframeGame = ({ userResponse }) => {

    return (
        <>
            {userResponse?.result?.user_response?.map((item, index) => {
                switch (item.response_type) {
                  case "iframe_experience":
                      if (item.response.includes("wayin")) {
                        return (
                          <>
                            <iframe src={item.response}
                                    title="Game"
                                    className="iframe-game"
                                    frameborder="0"
                                    scrolling="no"
                                    width="100%"
                                    height="100"
                                    id="ngxFrame287250"
                                    allowTransparency="true"></iframe>
                          </>
                        );
                      } else {
                        return (
                          <>
                            <iframe src={item.response} title="Game" className="iframe-game" frameBorder="0"></iframe>
                          </>
                        );
                      }
                    default:
                        return null;
                }
            })}
        </>
    )
}
export default IframeGame;
